export enum NativeType {
  MINI_PROGRAM = 1,
  APP = 2,
}